export const environment = {
  production: true,
  directusUrl: 'https://staging.data.jcinusantara.or.id',
  authProvider: 'auth0',
  googleMapsApiKey: 'AIzaSyAw1-VWXtyQ8hHTDbCAQNGkEYJ7CujOKL8',
  videoConferenceSetupFlowId: '015c599c-f9ec-4a7e-82b9-1d58c1f57411',
  // Service token used as fallback when officer role lacks read access to certain collections (e.g. profiles).
  // This is a read-only service account token scoped to public data already accessible on the website.
  directusMembersToken: '59c731caf5e64a08d42391d9dc02414ef57c17b2dedd2d3e8ebcb4e1222ad95d'
};
